import { BANK_NO } from '@/constants'

// 银行图标
export const BANK_ICON_MAP = {
  [BANK_NO.krungsri]: 'icon_k_bank_icon',

  [BANK_NO.SCB]: 'icon-24-SCB'
}
